export default "__VITE_ASSET__DJ0hOky$__"